import React, { useState } from "react";

const Questioni = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="faq-section animated"
      onMouseEnter={toggleAccordion}
      onMouseLeave={toggleAccordion}
    >
      <div
        className={`faq-header ${isOpen ? "open" : ""}`}
        onClick={toggleAccordion}
      >
        <div className="faq-question">
          How quickly can I get started with a virtual assistant?
        </div>
        {/* <div
          className="faq-icon"
          style={{ fontSize: "40px", paddingRight: "20px" }}
        >
          {isOpen ? "-" : "+"}
          <FontAwesomeIcon icon="fa-circle-question" color="black" />
        </div> */}
      </div>
      {isOpen && (
        <div className="faq-answer">
          <span>
            Following a meticulous process of matching clients with the most
            suitable virtual assistant or team of virtual assistants, we proceed
            with the onboarding procedure to commence your work seamlessly.
          </span>
        </div>
      )}
    </div>
  );
};

export default Questioni;
